import { Component, OnInit } from '@angular/core';
import { CrudService } from '../service/crud.service';
import { ECRService } from '../service/ecr.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-view-reportees-ecr',
  templateUrl: './view-reportees-ecr.component.html',
  styleUrls: ['./view-reportees-ecr.component.css']
})
export class ViewReporteesECRComponent implements OnInit {
  UserName: any;
  Reportees: any;
  IsHRAdmin: any;
  initialUserName = '';
  Reporte: any = [];

  reporteeData: any = [];
  isLoading = false;
  private pendingReportees = 0;

  managerData: any = [];
  tmcManager: any = '';
  year: any = '2023';
  month: number = new Date().getMonth() + 1;
  yearList: any = [];
  monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
  ];
  constructor(private _ecrService: ECRService, private _crudService: CrudService, private router: Router, private spinner: NgxSpinnerService) {
    this.UserName = sessionStorage.getItem("FullName");
    this.tmcManager = localStorage.getItem("userId");
    this.Reportees = sessionStorage.getItem("Reportees");
    this.Reporte = this.Reportees.split(",");


    const date = new Date();
const currentYear = date.getFullYear();

this.yearList = [
  currentYear,
  currentYear - 1,
  currentYear - 2
];

this.year = currentYear;
  }

  shortName(full_name: any) {
    if (!full_name) {
      return 'NA';
    }
    const arr = full_name.split(' ');
    let ans = '';
    for (let i = 0; i < arr.length; i++) {
      const ans1 = arr[i].split('');
      ans = ans + ans1[0];
      ans = ans.replace('undefined', '');
    }
    return ans.toUpperCase();
  }

  get teamCount(): number {
    return this.reporteeData ? this.reporteeData.length : 0;
  }

  get totalTeamEcrs(): number {
    if (!this.reporteeData || !this.reporteeData.length) {
      return 0;
    }
    let sum = 0;
    for (let i = 0; i < this.reporteeData.length; i++) {
      sum += this.reporteeData[i].CountofFilledECR || 0;
    }
    return sum;
  }

  get averageEcrsPerMember(): string {
    if (!this.teamCount) {
      return '0';
    }
    return (this.totalTeamEcrs / this.teamCount).toFixed(2);
  }

  getMonthName(m: number): string {
    const found = this.monthOptions.find(opt => opt.value === Number(m));
    return found ? found.label : '';
  }

  trackByTmc(index: number, emp: any): any {
    return emp ? emp.tmc : index;
  }

  getBranchLineWidth(): string {
    const n = this.teamCount;
    if (n <= 1) {
      return '0';
    }
    if (n === 2) {
      return '220px';
    }
    if (n === 3) {
      return '480px';
    }
    if (n === 4) {
      return '640px';
    }
    return 'min(92%, ' + (n * 200) + 'px)';
  }

  ngOnInit() {
    this.getECRManagerData(this.tmcManager);
    this.getReporteesName();
  }




  getReporteesName() {
    if (!this.Reporte || this.Reporte.length === 0) {
      this.reporteeData = [];
      this.isLoading = false;
      return;
    }

    const sorted = this.Reporte.slice().sort(function (a: any, b: any) {
      return a.toString().localeCompare(b.toString());
    });

    this.reporteeData = [];
    this.isLoading = true;
    this.pendingReportees = 0;
    const apiCalls = sorted.map((tmc: any) =>
      this._crudService.get('ecr/GetEmpDetails?TmcNo=' + tmc)
    );

    forkJoin(apiCalls).subscribe((responses: any[]) => {
      const withData = responses.filter((res) => res && res.Data);
      if (withData.length === 0) {
        this.isLoading = false;
        return;
      }
      this.pendingReportees = withData.length;
      withData.forEach((res) => {
        this.loadReporteeEcr(res.Data);
      });
    }, () => {
      this.isLoading = false;
    });
  }

  loadReporteeEcr(tmc: any) {
    this._ecrService.GetReporteeECR(tmc.TMC, this.month, this.year).subscribe((d: any) => {
      const row = {
        name: tmc.Full_Name,
        tmc: tmc.TMC,
        CountofFilledECR: (d.Data && d.Data.length) ? d.Data[0].CountofFilledECR : 0,
        WorkingDay: (d.Data && d.Data.length) ? d.Data[0].WorkingDay : 0
      };
      this.reporteeData = this.reporteeData.concat([row]).sort(function (a: any, b: any) {
        return (a.name || '').localeCompare(b.name || '');
      });
      this.finishReporteeLoad();
    }, () => {
      this.finishReporteeLoad();
    });
  }

  private finishReporteeLoad() {
    this.pendingReportees--;
    if (this.pendingReportees <= 0) {
      this.isLoading = false;
    }
  }

  getECRManagerData(tmc: any) {
    this._ecrService.GetReporteeECR(tmc, this.month, this.year).subscribe((d: any) => {
      this.managerData = (d.Data && d.Data.length) ? d.Data[0] : { CountofFilledECR: 0, WorkingDay: 0 };
    });
  }

  viewDetails(i: any) {
    this.router.navigate(['/ecr-status/'], { queryParams: { t: window.btoa(i.tmc), ref: window.btoa(i.name), m: this.month } });
  }


  submit() {
    this.getECRManagerData(this.tmcManager);
    this.getReporteesName();
  }

}
